export const handleInvalidToken = (navigate) => {
	localStorage.clear();
	navigate("/login", { replace: true });
};
